import PropTypes from "prop-types";

const asyncSelectType = PropTypes.shape({
  value: PropTypes.string,
  label: PropTypes.string,
});

export default { asyncSelectType };
